<template>
  <div class="memory-bank">
    <div class="header">
      <button class="create primary"
              @click="handleUpload">{{$t('newProjectV2.uploadMemory')}}</button>
      <div class="header-right">
        {{$t('newProjectV2.mounted')}}<span class="num">{{mountNum}}</span>
        <button @click="handleMount" class="mount primary">{{$t('newProjectV2.mount')}}</button>
        <button @click="handleCancelAll" class="create">{{$t('newProjectV2.cancelAll')}}</button>
      </div>
    </div>

    <div class="tab-content">
      <span @click="handleMemory('teamMemory')"
            :class="{ active: activeClass === 'teamMemory' }">{{$t('newProjectV2.teamMemoryBank')}}</span>
      <i>/</i>
      <span @click="handleMemory('publicMemory')"
            :class="{ active: activeClass === 'publicMemory' }">{{$t('newProjectV2.publicMemoryBank')}}</span>
    </div>

    <div class="memory-content">
      <el-table border height="100%" ref="multipleTable" :data="tableData" tooltip-effect="dark"
                @selection-change="handleSelectionChange" header-row-class-name="customHeader">
        <el-table-column align="center" type="selection" width="55">
        </el-table-column>
        <el-table-column :label="$t('newProjectV2.serialNumber')" align="center" width="55">
          <template slot-scope="{ $index }">
            {{$index + 1}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('newProjectV2.memoryBankName')" align="center" prop="name"
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column :label="$t('newProjectV2.domain')" align="center">
          <template slot-scope="{ row }">
            {{ $i18n.locale === 'zh' ? row.domainName : $domainCase[row.domainCode] }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('newProjectV2.sentNum')" align="center" prop="sentCount"
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column :label="'库类型'" align="center" :show-overflow-tooltip='true'>
          <template slot-scope="{ row }">{{ row.companyCode > 0 ? '私有库' : '公有库' }}</template>
        </el-table-column>
        <el-table-column :label="'备注'" align="center" :show-overflow-tooltip='true'>
          <template slot-scope="{ row }">{{ row.remark || '--' }}</template>
        </el-table-column>
        <el-table-column :label="$t('newProjectV2.mount')" align="center" prop="isEnable">
          <template slot-scope="{ row }">
            <el-switch v-model="row.isEnable" active-color="#0078FC" inactive-color="#DCDCDC">
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="memory-bottom">
      {{$t('newProjectV2.matchRate')}}<el-select size="small" @change="matchRateChange"
                 v-model="matchingRate" placeholder="请选择">
        <el-option label="70" :value="70"></el-option>
        <el-option label="80" :value="80"></el-option>
        <el-option label="90" :value="90"></el-option>
      </el-select>%
    </div>

    <UploadMemoryBank type="create" :visible="uploadVisible" @handleCancel="handleUploadCancel"
                      @updateMemoryBank="updateMemoryBank"></UploadMemoryBank>

  </div>
</template>

<script>
import UploadMemoryBank from '@/components/projectDialog/uploadMemoryBank';

export default {
  name: 'MemoryBank',
  props: {
    memoryList: {
      type: Array,
      default() {
        return [];
      }
    },
    matchRate: {
      type: Number,
      default() {
        return 0;
      }
    },
    publicMemoryList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  components: {
    UploadMemoryBank
  },
  data() {
    return {
      activeClass: 'teamMemory',
      // activeClass: 'teamMemory',
      tableData: [],
      memorySelection: [],
      matchingRate: this.matchRate,
      uploadVisible: false,
    }
  },
  methods: {
    // checkbox的change事件
    handleSelectionChange(selection) {
      this.memorySelection = selection;
    },
    handleCancelAll() {
      this.memoryList.forEach(item => {
        item.isEnable = false;
      });
      this.publicMemoryList.forEach(item => {
        item.isEnable = false;
      });
      this.$refs.multipleTable.clearSelection();
    },
    handleMount() {
      if (this.memorySelection.length === 0) {
        this.$message.closeAll();
        this.$message.warning(this.$t('newProjectV2.selMemoryBankTip'));
      }
      this.memorySelection.forEach(item => {
        this.memoryList.forEach(i => {
          if (i.id === item.id) {
            i.isEnable = true;
          }
        });
      });
      this.memorySelection.forEach(item => {
        this.publicMemoryList.forEach(i => {
          if (i.id === item.id) {
            i.isEnable = true;
          }
        });
      });
      // 取消选中
      this.$refs.multipleTable.clearSelection();
    },
    matchRateChange(newVal) {
      this.$emit('matchRateChange', newVal)
    },
    handleUpload() {
      this.uploadVisible = true;
    },
    handleUploadCancel() {
      this.uploadVisible = false;
    },
    updateMemoryBank() {
      this.$emit('updateMemoryBank', 'memory');
    },
    handleMemory(tabName) {
      if (tabName === this.activeClass) {
        return;
      }
      this.activeClass = tabName;
      if (tabName === 'publicMemory') {
        this.tableData = this.publicMemoryList;
      } else if (tabName === 'teamMemory') {
        this.tableData = this.memoryList;
      }
    },
  },
  watch: {
    memoryList: {
      handler(newVal) {
        if (this.activeClass === 'teamMemory') {
          this.tableData = newVal;
        }
      },
      deep: true,
    },
    publicMemoryList: {
      handler(newVal) {
        if (this.activeClass === 'publicMemory') {
          this.tableData = newVal;
        }
      },
      deep: true,
    },
  },
  computed: {
    mountNum() {
      return this.memoryList.filter(item => item.isEnable === true).length + this.publicMemoryList.filter(item => item.isEnable === true).length;
    }
  }
}
</script>

<style lang="less" scoped>
@import "./assets/newStyle.less";
</style>